const doc = [({"en":({"adminButtonCompany":({"updateCreditCardFees":"Update credit card fees", "updateSystemUsageFees":"Update system usage fees"})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;